var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _g, _ellipse2, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefit2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 329,
    viewBox: "0 0 450 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 233L-28 33V40L436 233Z",
    fill: "#C4D9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5 213.5L-28 61L-24 69L329.5 213.5Z",
    fill: "#C4D9F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143 164L-28 91V97L138 166.5L143 164Z",
    fill: "#C4D9F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 178.5L-28 121V126.5L110 182.5L113.5 178.5Z",
    fill: "#C4D9F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91 199L-28 145L-24 154.5L86.5 202L91 199Z",
    fill: "#C4D9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 217L-24 178.5V182.5L64 220L67.5 217Z",
    fill: "#C4D9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-24 205L104.5 261.5H138L192 213.5L378.5 357.5L76.5 321L84.7181 313.219L-24 268V264L87.1794 310.889L106.403 292.688L-28 229V225.5L108.802 290.416L123.5 276.5L-24 210V205Z",
    fill: "#C4D9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 345.5L-24 292V295L97.5 348L100.5 345.5Z",
    fill: "#C4D9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 342C8.66666 335 -24.8 319.8 -28 315V321L21.5 345.5L25 342Z",
    fill: "#C4D9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 235.5L93 252L328 260L89.5 235.5Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382 213C382 211.4 381.5 198.333 381.5 192L308.5 193.5C307.7 197.1 308.167 203 308.5 205.5C307.3 208.3 308 213.333 308.5 215.5C307.3 217.9 308 223.167 308.5 225.5C306.5 243 329 252 331 252C333 252 377.5 267.5 394 250C407.2 236 391.833 224.833 382.5 221L382 213Z",
    fill: "#C4D9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 131L328 260L35 237L86 189.5L98.5 193.5L101 176L149.5 131Z",
    fill: "#FEFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223 184L133.5 146L131.5 148L223 184Z",
    fill: "#D0D0D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 240.5L47 226L48.5 224.5L84.5 240.5Z",
    fill: "#D0D0D0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 205L68 206.5L165.5 246.5L69.5 205Z",
    fill: "#D0D0D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110 167.5L112 165.5L200.5 205L110 167.5Z",
    fill: "#D0D0D0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329 260L100.5 176.5L98.5 193L329 260Z",
    fill: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_55",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 175,
    width: 68,
    height: 74
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193,
    cy: 212,
    rx: 31.8431,
    ry: 38.5229,
    transform: "rotate(-30.5376 193 212)",
    fill: "#F5C767"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_55)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 193,
    cy: 212,
    rx: 31.8431,
    ry: 38.5229,
    transform: "rotate(-30.5376 193 212)",
    fill: "#F5C767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.5 184L205.5 189.5L199 191.5L163 186.5L167.5 181.5C185.1 165.9 204.167 176.667 211.5 184Z",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 191.442,
    width: 9.88168,
    height: 2,
    transform: "rotate(-40.6857 206 191.442)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 193.442,
    width: 9.88168,
    height: 2,
    transform: "rotate(-40.6857 208 193.442)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.712,
    y: 194.836,
    width: 9.88168,
    height: 2,
    transform: "rotate(-33.0511 209.712 194.836)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 197.625,
    width: 9.88168,
    height: 2,
    transform: "rotate(-34.6959 212 197.625)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.827,
    y: 200.816,
    width: 9.88168,
    height: 2,
    transform: "rotate(-34.6959 212.827 200.816)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.608,
    y: 203.013,
    width: 9.88168,
    height: 2,
    transform: "rotate(-34.6959 214.608 203.013)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.388,
    y: 205.211,
    width: 9.88168,
    height: 2,
    transform: "rotate(-34.6959 216.388 205.211)",
    fill: "#FAE7BC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.873,
    cy: 213.993,
    rx: 28.999,
    ry: 37.8871,
    transform: "rotate(-30.5376 190.873 213.993)",
    fill: "#F5C767"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345,
    cy: 192.5,
    rx: 37,
    ry: 24.5,
    fill: "#EDF5FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124 200.5L248 236.5L211.5 249L199.5 249.5L185.5 247.5L165.5 238L124 200.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit2);
export default __webpack_public_path__ + "static/media/benefit2.355a5f8b8175cd831b4c8c7b6ef83119.svg";
export { ForwardRef as ReactComponent };